
/**
 * This object is a singleton instance of a session.
 */
let session = (function () {
	let t = {};

	// Defines a route which is set before a login
	let beforeLoginRoute = null;

    let user = {
        id: 0,
        email: '',
    };
	/**
	 * login function
	 * @public
	 *
	 * @param {string} username
	 * @param {string} password
	 * @param {boolean} rememberlogin
	 * @returns {*}
	 */
	t.login = function (username, password, rememberlogin) {
		return httpClient.login({
			"username": username,
			"password": password,
		}).then(function (response) {
			return response;
		});
	};

    /**
	 * Logout function
	 *
     * @returns {Promise<Object | never>}
     */
    t.logout = function () {
        return httpClient.post("/logoff")
			.then((response) => {
				return response;
        	});
    };



    /**
     * Get the user information
     * @public
     * @return {{}}
     */
    t.getUser = function () {
        return user;
    };

    /**
     * is logged in. Will return a promise with true or false
     * @public
     * @return {Promise}
     */
    t.isLoggedIn = function () {
        return httpClient.post('login/check')
            .then(response => {
                return response.access === 1;
            }).catch(error => {
                this.$message({
                    message: error.message,
                    type: "error"
                });
                console.log(error);
            });
    };

	/**
	 * Get the user information
	 * @public
	 * @return {{}}
	 */
	t.getUser = function () {
		return user;
	};

	/**
	 * Autologin function to be called by the vue router
	 * @public
	 *
	 * @param to
	 * @param from
	 * @param next
	 */
	t.autoLogin = function (to, from, next) {

		t.isLoggedIn()
			.then(function (isLoggedIn) {
				if (isLoggedIn) {
					// Continue
					if (to.path !== '/login') {
						redirect(next);
					} else {
						// ... Unless you're going to the login page. Then back to main.
						next('/');
					}
				} else {

					// Not logged in and no stored token - go to the login page.
					if (to.path === '/login') {
						next();
					}
					else {
						// Store the route entered before
						// Redirecting to the login route
						beforeLoginRoute = to;
						next("/login");
					}
				}
			})

    };

	let redirect = function(next) {
		let resolvedPath = beforeLoginRoute || undefined;
		if (beforeLoginRoute !== null) {
			resolvedPath = beforeLoginRoute.path || undefined;
			beforeLoginRoute = null;
		}

		next(resolvedPath);
	};

	/**
	 * self executing Session keep alive which executes
	 * the login function, to preserve the current login,
	 * when viewing or editing a dashboard.
	 * @private
	 */
    (function keepAlive() {

		t.isLoggedIn().then(isLoggedIn => {
			// Keep-alive successfully executed
		});
        setTimeout(keepAlive, 1000 * 300);
    })();

	return t;
})();
